import React, { useState } from 'react';
import {
  Check,
  CheckCircle,
  XCircle,
  Trash2,
  Ban,
  Loader,
  Eye,
  User,
  Mail,
  Phone,
  Image,
  Package,
  Palette,
  Clock,
  Copy,
  CheckCircle2
} from 'lucide-react';
import { useDevis } from '../context/DevisContext';
import { formatQuantities } from '../utils/formatters';
import { QuoteDetailsModal } from './QuoteModals';

const DevisTable = () => {

  const [copiedColorId, setCopiedColorId] = useState(null);


  const {
    currentQuotes,
    selectedQuotes,
    expandedQuantities,
    hoveredEmail,
    processingQuotes,
    confirmLoading,
    toggleQuantityExpansion,
    handleSelectAll,
    handleQuoteSelect,
    obfuscateEmail,
    getStatusColor,
    getStatusText,
    // openImageModal,
    openRejectModal,
    openDeleteModal,
    confirmQuote,
    setHoveredEmail,
    setShowDetailsModal,
    fetchQuoteDetails
  } = useDevis();

  if (currentQuotes.length === 0) {
    return null;
  }

  return (
    <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-white/20 overflow-hidden">
      <QuoteDetailsModal />

      {/* Table Header */}
      <div className="bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 px-4 sm:px-6 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <Package className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-semibold text-white">Liste des Devis</h3>
              <p className="text-green-100 text-xs sm:text-sm">{currentQuotes.length} devis au total</p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="bg-white/20 rounded-lg px-3 py-1.5">
              <span className="text-white text-xs sm:text-sm font-medium">
                {selectedQuotes.length} sélectionné{selectedQuotes.length > 1 ? 's' : ''}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Table - Hidden on Mobile */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left">
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    currentQuotes.length > 0 &&
                    selectedQuotes.length === currentQuotes.length
                  }
                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded transition duration-150 ease-in-out"
                />
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <User className="w-4 h-4" />
                  <span>Client</span>
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <Mail className="w-4 h-4" />
                  <span>Contact</span>
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <Phone className="w-4 h-4" />
                  <span>Téléphone</span>
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <Image className="w-4 h-4" />
                  <span>Logo</span>
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <Package className="w-4 h-4" />
                  <span>Quantité</span>
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <Palette className="w-4 h-4" />
                  <span>Couleurs</span>
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <Clock className="w-4 h-4" />
                  <span>Statut</span>
                </div>
              </th>

              {/* Logo price */}

              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center space-x-2">
                  <Clock className="w-4 h-4" />
                  <span>Price Logo</span>
                </div>
              </th>


              <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <div className="flex items-center justify-center space-x-2">
                  <Eye className="w-4 h-4" />
                  <span>Actions</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {currentQuotes.map((quote, index) => (
              <tr
                key={quote.id}
                className="group hover:bg-gradient-to-r hover:from-green-50 hover:to-emerald-50 cursor-pointer transition-all duration-300"
                onClick={(e) => {
                  // Prevent row click when clicking on checkbox or action buttons
                  if (e.target.type === 'checkbox' ||
                    e.target.closest('button') ||
                    e.target.closest('svg')) {
                    return;
                  }
                  // Open quote details
                  setShowDetailsModal(true);
                  fetchQuoteDetails(quote.id);
                }}
              >
                <td className="px-6 py-6" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selectedQuotes.includes(quote.id)}
                    onChange={() => handleQuoteSelect(quote.id)}
                    className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded transition duration-150 ease-in-out"
                  />
                </td>

                {/* Client Name */}
                <td className="px-6 py-6">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                      <User className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{quote.name}</p>
                      <p className="text-xs text-gray-500">Client #{quote.id}</p>
                    </div>
                  </div>
                </td>

                {/* Email */}
                <td className="px-6 py-6">
                  <div
                    className="relative group/email"
                    onMouseEnter={() => setHoveredEmail(quote.id)}
                    onMouseLeave={() => setHoveredEmail(null)}
                  >
                    <div className="flex items-center space-x-2">
                      <Mail className="w-4 h-4 text-gray-400" />
                      <span className="text-sm text-gray-700">{obfuscateEmail(quote.email)}</span>
                    </div>
                    {hoveredEmail === quote.id && quote.email && (
                      <div className="absolute z-20 bg-gray-900 text-white text-xs px-3 py-2 rounded-lg shadow-xl -top-12 left-0 whitespace-nowrap">
                        {quote.email}
                        <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                      </div>
                    )}
                  </div>
                </td>

                {/* Phone */}
                <td className="px-6 py-6">
                  <div className="flex items-center space-x-2">
                    <Phone className="w-4 h-4 text-gray-400" />
                    <span className="text-sm text-gray-700">{quote.phone}</span>
                  </div>
                </td>

                {/* Logo Status */}
                <td className="px-6 py-6">
                  <div className="flex items-center space-x-2">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center ${quote.is_logo_required
                      ? 'bg-green-100 text-green-600'
                      : 'bg-gray-100 text-gray-400'
                      }`}>
                      <Image className="w-4 h-4" />
                    </div>
                    <span className={`text-xs font-medium ${quote.is_logo_required ? 'text-green-600' : 'text-gray-500'
                      }`}>
                      {quote.is_logo_required ? 'Requis' : 'Non requis'}
                    </span>
                  </div>
                </td>

                {/* Quantity */}
                <td className="px-6 py-6">
                  <div className="flex items-center space-x-2">
                    <Package className="w-4 h-4 text-gray-400" />
                    <div className="text-sm text-gray-700">
                      {formatQuantities(quote, expandedQuantities, toggleQuantityExpansion)}
                    </div>
                  </div>
                </td>

                {/* Colors */}
                <td className="px-6 py-6">
                  <div className="flex items-center space-x-2">
                    <Palette className="w-4 h-4 text-gray-400" />
                    <div className="flex space-x-1">
                      {quote.product_colors?.length > 0 ? (
                        quote.product_colors.map((color, colorIndex) => {
                          const uniqueKey = `${quote.id}-${colorIndex}`;
                          return (
                            <div key={uniqueKey} className="relative group/color">
                              <div
                                className="w-8 h-8 rounded-full border-2 border-white shadow-md cursor-pointer hover:scale-110 transition-transform duration-200"
                                style={{ backgroundColor: color }}
                                title={`Cliquer pour copier ${color}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(color);
                                  setCopiedColorId(uniqueKey);
                                  setTimeout(() => setCopiedColorId(null), 2500);
                                }}
                              />
                              {copiedColorId === uniqueKey && (
                                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded-md shadow-lg whitespace-nowrap">
                                  <Copy className="w-3 h-3 inline mr-1" />
                                  Copié
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <span className="text-gray-400 text-xs">Aucune</span>
                      )}
                    </div>
                  </div>
                </td>

                {/* Status */}
                <td className="px-6 py-6">
                  <div className="flex items-center space-x-2">
                    <Clock className="w-4 h-4 text-gray-400" />
                    <span
                      className={`px-3 py-1 text-xs font-semibold rounded-full ${getStatusColor(
                        quote.status
                      )}`}
                    >
                      {getStatusText(quote.status)}
                    </span>
                  </div>
                </td>

                {/* Loigo Price */}
                <td className="px-6 py-6">
                  <div className="flex items-center space-x-2">
                    <Phone className="w-4 h-4 text-gray-400" />
                    <span className="text-sm text-gray-700">
                      {quote.price_logo_quote !== null
                        ? parseFloat(quote.price_logo_quote) + ' $'
                        : '0.00 $'}
                    </span>
                  </div>
                </td>
                {/* Actions */}
                <td className="px-6 py-6">
                  <div className="flex justify-center space-x-2">
                    {processingQuotes.includes(quote.id) || confirmLoading === quote.id ? (
                      <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-xl">
                        <Loader className="w-5 h-5 text-blue-600 animate-spin" />
                      </div>
                    ) : (
                      <>
                        {quote.status === "pending" && (
                          <div className="flex space-x-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                confirmQuote(quote.id);
                              }}
                              className="group relative w-10 h-10 bg-green-100 hover:bg-green-200 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                              title="Confirmer le devis"
                            >
                              <CheckCircle className="w-5 h-5 text-green-600 group-hover:text-green-700" />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openRejectModal(quote.id);
                              }}
                              className="group relative w-10 h-10 bg-red-100 hover:bg-red-200 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                              title="Refuser le devis"
                            >
                              <XCircle className="w-5 h-5 text-red-600 group-hover:text-red-700" />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openDeleteModal(quote.id);
                              }}
                              className="group relative w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                              title="Supprimer le devis"
                            >
                              <Trash2 className="w-5 h-5 text-gray-600 group-hover:text-gray-700" />
                            </button>
                          </div>
                        )}

                        {quote.status === "confirmed" && (
                          <div className="flex space-x-2">
                            <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
                              <Check className="w-5 h-5 text-green-600" title="Devis confirmé" />
                            </div>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openDeleteModal(quote.id);
                              }}
                              className="group relative w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                              title="Supprimer le devis"
                            >
                              <Trash2 className="w-5 h-5 text-gray-600 group-hover:text-gray-700" />
                            </button>
                          </div>
                        )}

                        {quote.status === "rejected" && (
                          <div className="flex space-x-2">
                            <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center">
                              <Ban className="w-5 h-5 text-red-600" title={`Devis refusé: ${quote.rejection_reason}`} />
                            </div>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openDeleteModal(quote.id);
                              }}
                              className="group relative w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                              title="Supprimer le devis"
                            >
                              <Trash2 className="w-5 h-5 text-gray-600 group-hover:text-gray-700" />
                            </button>
                          </div>
                        )}

                        {quote.status === "paid" && (
                          <div className="flex space-x-2">
                            <div className="w-10 h-10 bg-emerald-100 rounded-xl flex items-center justify-center">
                              <CheckCircle2 className="w-5 h-5 text-emerald-600" title="Devis payé" />
                            </div>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openDeleteModal(quote.id);
                              }}
                              className="group relative w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110"
                              title="Supprimer le devis"
                            >
                              <Trash2 className="w-5 h-5 text-gray-600 group-hover:text-gray-700" />
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile/Tablet Card View */}
      <div className="lg:hidden divide-y divide-gray-100">
        {currentQuotes.map((quote) => (
          <div
            key={quote.id}
            className="p-4 hover:bg-gradient-to-r hover:from-green-50 hover:to-emerald-50 transition-all duration-300"
            onClick={() => {
              setShowDetailsModal(true);
              fetchQuoteDetails(quote.id);
            }}
          >
            {/* Card Header */}
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-start space-x-3 flex-1">
                <input
                  type="checkbox"
                  checked={selectedQuotes.includes(quote.id)}
                  onChange={(e) => {
                    e.stopPropagation();
                    handleQuoteSelect(quote.id);
                  }}
                  onClick={(e) => e.stopPropagation()}
                  className="h-5 w-5 text-green-600 focus:ring-green-500 border-gray-300 rounded mt-1 flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2 mb-1">
                    <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <User className="w-4 h-4 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-gray-900 truncate">{quote.name}</p>
                      <p className="text-xs text-gray-500">Client #{quote.id}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Status Badge */}
              <span
                className={`px-2.5 py-1 text-xs font-semibold rounded-full whitespace-nowrap flex-shrink-0 ml-2 ${getStatusColor(
                  quote.status
                )}`}
              >
                {getStatusText(quote.status)}
              </span>
            </div>

            {/* Contact Info */}
            <div className="space-y-2 mb-3 ml-11">
              <div
                className="relative"
                onMouseEnter={() => setHoveredEmail(quote.id)}
                onMouseLeave={() => setHoveredEmail(null)}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex items-center space-x-2">
                  <Mail className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
                  <span className="text-xs text-gray-700 truncate">{obfuscateEmail(quote.email)}</span>
                </div>
                {hoveredEmail === quote.id && quote.email && (
                  <div className="absolute z-20 bg-gray-900 text-white text-xs px-3 py-2 rounded-lg shadow-xl -top-12 left-0 whitespace-nowrap">
                    {quote.email}
                    <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                  </div>
                )}
              </div>

              <div className="flex items-center space-x-2">
                <Phone className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
                <span className="text-xs text-gray-700">{quote.phone}</span>
              </div>
            </div>

            {/* Details Grid */}
            <div className="grid grid-cols-2 gap-3 mb-3 ml-11">
              {/* Logo */}
              <div className="flex items-center space-x-2">
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 ${quote.is_logo_required
                  ? 'bg-green-100 text-green-600'
                  : 'bg-gray-100 text-gray-400'
                  }`}>
                  <Image className="w-3 h-3" />
                </div>
                <span className={`text-xs font-medium ${quote.is_logo_required ? 'text-green-600' : 'text-gray-500'
                  }`}>
                  {quote.is_logo_required ? 'Logo requis' : 'Pas de logo'}
                </span>
              </div>

              {/* Quantity */}
              <div className="flex items-center space-x-2">
                <Package className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
                <div className="text-xs text-gray-700">
                  {formatQuantities(quote, expandedQuantities, toggleQuantityExpansion)}
                </div>
              </div>
            </div>

            {/* Colors */}
            <div className="flex items-center space-x-2 mb-3 ml-11">
              <Palette className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
              <div className="flex space-x-1 flex-wrap gap-1">
                {quote.product_colors?.length > 0 ? (
                  quote.product_colors.map((color, colorIndex) => {
                    const uniqueKey = `${quote.id}-${colorIndex}`;
                    return (
                      <div key={uniqueKey} className="relative group/color">
                        <div
                          className="w-6 h-6 rounded-full border-2 border-white shadow-md cursor-pointer hover:scale-110 transition-transform duration-200"
                          style={{ backgroundColor: color }}
                          title={`Cliquer pour copier ${color}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(color);
                            setCopiedColorId(uniqueKey);
                            setTimeout(() => setCopiedColorId(null), 2500);
                          }}
                        />
                        {copiedColorId === uniqueKey && (
                          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded-md shadow-lg whitespace-nowrap z-10">
                            <Copy className="w-3 h-3 inline mr-1" />
                            Copié
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <span className="text-gray-400 text-xs">Aucune couleur</span>
                )}
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end space-x-2 ml-11" onClick={(e) => e.stopPropagation()}>
              {processingQuotes.includes(quote.id) || confirmLoading === quote.id ? (
                <div className="flex items-center justify-center w-9 h-9 bg-blue-100 rounded-xl">
                  <Loader className="w-4 h-4 text-blue-600 animate-spin" />
                </div>
              ) : (
                <>
                  {quote.status === "pending" && (
                    <div className="flex space-x-2">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          confirmQuote(quote.id);
                        }}
                        className="w-9 h-9 bg-green-100 hover:bg-green-200 rounded-xl flex items-center justify-center transition-all duration-300"
                        title="Confirmer le devis"
                      >
                        <CheckCircle className="w-4 h-4 text-green-600" />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openRejectModal(quote.id);
                        }}
                        className="w-9 h-9 bg-red-100 hover:bg-red-200 rounded-xl flex items-center justify-center transition-all duration-300"
                        title="Refuser le devis"
                      >
                        <XCircle className="w-4 h-4 text-red-600" />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteModal(quote.id);
                        }}
                        className="w-9 h-9 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300"
                        title="Supprimer le devis"
                      >
                        <Trash2 className="w-4 h-4 text-gray-600" />
                      </button>
                    </div>
                  )}

                  {quote.status === "confirmed" && (
                    <div className="flex space-x-2">
                      <div className="w-9 h-9 bg-green-100 rounded-xl flex items-center justify-center">
                        <Check className="w-4 h-4 text-green-600" title="Devis confirmé" />
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteModal(quote.id);
                        }}
                        className="w-9 h-9 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300"
                        title="Supprimer le devis"
                      >
                        <Trash2 className="w-4 h-4 text-gray-600" />
                      </button>
                    </div>
                  )}

                  {quote.status === "rejected" && (
                    <div className="flex space-x-2">
                      <div className="w-9 h-9 bg-red-100 rounded-xl flex items-center justify-center">
                        <Ban className="w-4 h-4 text-red-600" title={`Devis refusé: ${quote.rejection_reason}`} />
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteModal(quote.id);
                        }}
                        className="w-9 h-9 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300"
                        title="Supprimer le devis"
                      >
                        <Trash2 className="w-4 h-4 text-gray-600" />
                      </button>
                    </div>
                  )}

                  {quote.status === "paid" && (
                    <div className="flex space-x-2">
                      <div className="w-9 h-9 bg-emerald-100 rounded-xl flex items-center justify-center">
                        <CheckCircle2 className="w-4 h-4 text-emerald-600" title="Devis payé" />
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteModal(quote.id);
                        }}
                        className="w-9 h-9 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-300"
                        title="Supprimer le devis"
                      >
                        <Trash2 className="w-4 h-4 text-gray-600" />
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DevisTable;